import axios from 'axios';
import { clearAuthData } from './auth';

// ms-reports-ltv. Defina VITE_LTV_API_URL no .env (ex: https://ltv.rocketgroup.io)
const LTV_API_URL = import.meta.env.VITE_LTV_API_URL || 'http://localhost:8007';

const ltvClient = axios.create({
    baseURL: LTV_API_URL,
    headers: { 'Content-Type': 'application/json' },
});

// Anexa o Bearer token (mesmo padrão do client.ts / meta-client.ts)
ltvClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

ltvClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default ltvClient;
